import { BusinessUnitsData } from 'client/bundles/types';
import cn from 'client/utils/cn';
import React, { Component } from 'react';

import './index.css';

const b = cn('country-descriptor');

interface Props {
    country: string;
    description: string;
    businessUnitsLabel?: string;
    businessUnits?: BusinessUnitsData[];
}

class CountryDescriptor extends Component<Props> {
    render() {
        const { country, description, businessUnits = [], businessUnitsLabel } = this.props;

        return (
            <section className={b()}>
                <h3 className={b('hint-title')}>{country}</h3>
                {description && (
                    <div className={b('hint-content')}>{description}</div>
                )}
                {businessUnits.length > 0 && (
                    <div className={b('units')}>
                        <p className={b('units-label')}>{businessUnitsLabel}</p>
                        <div className={b('units-list')}>
                            {businessUnits.map(({ id, logo, url, title }) => (
                                <a
                                    key={id}
                                    className={b('unit')}
                                    title={title}
                                    href={url}
                                    style={{ backgroundImage: `url(${logo})` }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    />
                            ))}
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default CountryDescriptor;
